var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27452 3.5C5.63762 3.5 3.5 5.63763 3.5 8.27453C3.5 10.9114 5.63762 13.049 8.27452 13.049C10.9114 13.049 13.049 10.9114 13.049 8.27453C13.049 5.63763 10.9114 3.5 8.27452 3.5ZM2 8.27453C2 4.80921 4.80919 2 8.27452 2C11.7398 2 14.549 4.80921 14.549 8.27453C14.549 9.73692 14.0488 11.0825 13.21 12.1493L17.7803 16.7197C18.0732 17.0126 18.0732 17.4874 17.7803 17.7803C17.4875 18.0732 17.0126 18.0732 16.7197 17.7803L12.1493 13.21C11.0825 14.0488 9.73691 14.549 8.27452 14.549C4.8092 14.549 2 11.7399 2 8.27453Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "c4cf9dbb29dabe13ed9d29e257f8dcb7.svg";
export { ForwardRef as ReactComponent };